import { Drawer } from "antd";
import CreateGameForm from "./CreateGameForm";
import { useEffect, useState } from "react";

export default function CreateGame({ open, onClose }) {
  const [drawerWidth, setDrawerWidth] = useState(600);

  useEffect(() => {
    const updateWidth = () => {
      if (window.innerWidth < 768) {
        setDrawerWidth("100%"); // Full width on small screens
      } else if (window.innerWidth < 1024) {
        setDrawerWidth(400); // Medium size for tablets
      } else {
        setDrawerWidth(600); // Default width for desktops
      }
    };

    updateWidth(); // Set width initially
    window.addEventListener("resize", updateWidth); // Listen for resize events

    return () => window.removeEventListener("resize", updateWidth);
  }, []);
  return (
    <Drawer
      width={drawerWidth}
      title='Add Game Room'
      placement='right'
      onClose={onClose}
      open={open}
      destroyOnClose={true}
    >
      <CreateGameForm onClose={onClose} />
    </Drawer>
  );
} 
